import { z } from "zod";
import { congressAttributionSchema } from "../../congress/congressAttribution";

const crumbSchema = z.object({ label: z.string(), to: z.string() });

/**
 * The router state a desktop collection hands the article it opens: the
 * collection's own breadcrumb trail (a room, a congress space) and its crumb.
 * The desktop article page continues that trail, so it still names the
 * collection the reader is walking and every page above it. The collection's
 * crumb keeps the congress the collection was opened from, so following it
 * back restores the congress crumb too. A cold entry (a shared link, a reload
 * on Safari) carries none.
 */
export const collectionOriginStateSchema = z.object({
  collectionOrigin: z
    .object({
      trail: z.array(crumbSchema),
      collection: z.object({
        label: z.string(),
        path: z.string(),
        congressAttribution: congressAttributionSchema.nullable(),
      }),
    })
    .nullable()
    .default(null),
});

export function collectionOriginState(
  collectionOrigin: NonNullable<
    z.input<typeof collectionOriginStateSchema>["collectionOrigin"]
  >
): z.input<typeof collectionOriginStateSchema> {
  return { collectionOrigin };
}
